"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledFlyoutItem = exports.StyledFlyout = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _shared = require("../../shared");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledFlyout = _styledComponents.default.div.withConfig({
  displayName: "Flyoutstyles__StyledFlyout",
  componentId: "sc-ekyish-0"
})(["position:relative;", ";z-index:", ";.content{background-color:", ";border:1px solid ", ";box-shadow:0px 6px 16px rgba(115,127,143,0.16);border-radius:4px;.content-inner{box-sizing:border-box;border-radius:4px;overflow:", ";}}"], ({
  width
}) => `width: ${width}`, _shared.theme.zIndex.context, _shared.theme.palette.brand.primary.white, _shared.theme.palette.ui.neutral.grey2, ({
  overflow
}) => overflow ? overflow : 'hidden');

exports.StyledFlyout = StyledFlyout;

const StyledFlyoutItem = _styledComponents.default.div.withConfig({
  displayName: "Flyoutstyles__StyledFlyoutItem",
  componentId: "sc-ekyish-1"
})(["font-size:13px;line-height:16px;letter-spacing:0.02em;text-decoration:none;color:", ";padding:10px 23px;box-sizing:border-box;transition:all 0.2s ease-in-out;cursor:pointer;&:hover{background-color:", ";}"], _shared.theme.palette.brand.primary.charcoal, _shared.theme.palette.ui.neutral.grey5);

exports.StyledFlyoutItem = StyledFlyoutItem;